import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme.js";
import { AuthProvider } from './AuthProvider.js';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';


const root = document.getElementById("root");
const reactRoot = createRoot(root);

reactRoot.render(
  <ChakraProvider theme={theme} resetCss={false} position="relative">
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      language="es"
      useRecaptchaNet={true}
      useEnterprise={false}
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
        nonce: undefined // optional, default undefined
      }}>

      <HashRouter>
        <AuthProvider>
          <Switch>
            <Route path={`/auth`} component={AuthLayout} />
            <Route path={`/admin`} component={AdminLayout} />
            <Redirect from={`/`} to="/admin/dashboard" />
          </Switch>
        </AuthProvider>
      </HashRouter>
    </GoogleReCaptchaProvider>
  </ChakraProvider>
);
